import React, { FC, ReactNode } from "react";
import * as s from "./styles";
import { SUGGESTED_DATE_FORMAT } from "src/constants";

type LabelProps = {
  children: ReactNode;
};

export const LabelWithDateFormat: FC<LabelProps> = ({ children }) => (
  <s.DateLabelWrap>
    {children}
    <span>({SUGGESTED_DATE_FORMAT})</span>
  </s.DateLabelWrap>
);
